import React from 'react';
import classnames from 'classnames';
import Isvg from 'react-inlinesvg';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import NavLink from 'app/components/general/NavLink';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import pluralize from 'pluralize';

import {
  Collapse, Navbar, Nav, NavItem,
} from 'reactstrap';

import TeammoLogo from 'app/images/logo-white.svg';
import BillingIcon from 'app/images/icons/billing.svg';
import DownArrowIcon from 'app/images/icons/down-arrow.svg';
import HomeIcon from 'app/images/icons/home.svg';
import HelpIcon from 'app/images/icons/help.svg';
import LogoutIcon from 'app/images/icons/logout.svg';
import DotsIcon from 'app/images/icons/dots.svg';
import SettingsIcon from 'app/images/icons/settings.svg';
import CreditCardIcon from 'app/images/icons/credit-card.svg';
import CompetitionIcon from 'app/images/icons/organisation.svg';
import EventsIcon from 'app/images/icons/events.svg';
import PersonIcon from 'app/images/icons/person.svg';
import CustomersIcon from 'app/images/icons/customers.svg';
import TeamIcon from 'app/images/icons/team.svg';
import RequestIcon from 'app/images/icons/request.svg';
import MenuIcon from 'app/images/icons/menu.svg';
import CrossIcon from 'app/images/icons/cross.svg';
import ConnectionIcon from 'app/images/icons/connection.svg';
import ReportsIcon from 'app/images/icons/reports.svg';
import NewWindowIcon from 'app/images/icons/new-window.svg';


interface ITopBarProps {
  actions: any;
  match: any;
  authentication: any;
  admins: any;
  organisations: any;
  flags: any;
  firstName: string;
  lastName: string;
  competitionName: string;
  competitionid: string;
  handleStripeBilling: Function;
}

interface ITopBarState {
  isOpen: boolean;
}
class TopBar extends React.Component<ITopBarProps, ITopBarState> {
  static defaultProps: ITopBarProps = {
    actions: {},
    match: {},
    admins: {},
    authentication: {},
    organisations: {},
    flags: {},
    firstName: '',
    lastName: '',
    competitionName: '',
    competitionid: '',
    handleStripeBilling: undefined,
  };

  state: ITopBarState = {
    isOpen: false,
  };

  toggleOpen = (): void => {
    this.setState({
      isOpen: true,
    });
    document.body.classList.add('lock-position');
  };

  toggleClose = (): void => {
    this.setState({
      isOpen: false,
    });
    document.body.classList.remove('lock-position');
  };

  renderGroupOptions = (): React.ReactNode => {
    if (
      this.props.organisations.currentOrganisation !== undefined
      && !this.props.organisations.currentOrganisation.groupTypes !== undefined
    ) {
      return _.map(
        this.props.organisations.currentOrganisation.groupTypes,
        (group) => (
          <NavItem key={group.code}>
            <NavLink
              onClick={this.toggleClose}
              className={classnames({
                active:
                  this.props.match.url
                  === `/teams/segments/${pluralize(group.code)}`,
              })}
              to={`/teams/segments/${pluralize(group.code)}`}
            >
              {group.name}
            </NavLink>
          </NavItem>
        ),
      );
    }
    return null;
  };

  renderPaymentOptions = (): React.ReactNode => {
    if (
      this.props.organisations.currentOrganisation !== undefined
      && this.props.organisations.currentOrganisation.paymentRecordTypes
        !== undefined
    ) {
      return _.map(
        this.props.organisations.currentOrganisation.paymentRecordTypes,
        (payment) => (
          <NavItem key={payment.code}>
            <NavLink
              onClick={this.toggleClose}
              className={classnames({
                active:
                  this.props.match.url
                  === `/payments/segments/${pluralize(payment.code)}`,
              })}
              to={`/payments/segments/${pluralize(payment.code)}`}
            >
              {payment.name}
            </NavLink>
          </NavItem>
        ),
      );
    }
    return null;
  };

  renderCompetitionsSelector = (): React.ReactNode => {
    if (this.props.competitionName !== undefined) {
      return (
        <NavLink
          onClick={this.toggleClose}

          className={classnames(
            {
              active: this.props.match.path === '/competitions',
            },
            'team-selector-nav-link',
          )}
          to="/competitions"
        >
          <div>
            <div className="team-selector-group">
              <span className="team-selector-text">
                {this.props.competitionName}
              </span>
              <Isvg className="team-selector-icon" src={DotsIcon} />
            </div>
          </div>
        </NavLink>
      );
    }
    return null;
  };

  handleOrganisationChange = (e): void => {
    if (e && e.id != null) {
      this.props.actions.switchOrganisation(
        e.id,
      );
      // this.props.actions.globalLoad();
    }
  }

  renderSudoSelector = (): React.ReactNode => {
    const orgValue = _.find(this.props.organisations.organisationsByIdInSelectFormat, (t) => t.id === this.props.authentication.organisationId);
    return (
      <div className="sudo-switch-organisation">
        <InputGroupBlock
          type="select"
          name="organisation"
          placeholder="Sports organisation/league"
          aria-label="Sports organisation/league"
          inputGroupClassName="no-margin-bottom"
          autoComplete="off"
          value={orgValue}
          options={
            this.props.organisations.organisationsByIdInSelectFormat
          }
          onChange={this.handleOrganisationChange}
        />
      </div>
    );
  };

  render(): React.ReactNode {
    const featureFlags = this.props.organisations?.currentOrganisation?.featureFlags;
    const teammoAdmin = this.props.admins?.currentAdmin?.roleType === 'teammo-admin';
    const bolShowDashboard = teammoAdmin || featureFlags?.showAnalyticsDashboard || true;
    const bolShowPaymentRequests = teammoAdmin || featureFlags?.showPaymentRequests || false;
    const bolShowMatchPayments = teammoAdmin || featureFlags?.showMatchPayments || false;
    const bolShowCustomers = teammoAdmin || featureFlags?.showCustomers || false;
    const bolShowTeams = teammoAdmin || featureFlags?.showTeams || false;
    const bolShowEventDashboard = teammoAdmin || featureFlags?.showEventDashboard || true;
    const bolShowConnections = teammoAdmin || featureFlags?.showConnections || true;
    const bolShowReports = teammoAdmin || featureFlags?.showReports || true;
    const bolShowBilling = teammoAdmin || featureFlags?.showBilling || false;
    return (
      <Navbar className="top-bar sticky-top">
        <Link className="navbar-brand" to="/">
          <Isvg className="header-logo" alt="Teammo" src={TeammoLogo} />
        </Link>
        <button
          onClick={this.toggleOpen}
          type="button"
          className="navbar-toggler navbar-toggler-right"
        >
          <span className="navbar-toggler-icon">
            <Isvg className="menu-icon" alt="Menu" src={MenuIcon} />
          </span>
        </button>
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="" navbar>
            {this.props.admins.currentAdmin?.roleType === 'teammo-admin' && this.renderSudoSelector()}
            {/* {this.renderCompetitionsSelector()} */}

            <div className="nav-top">
              {bolShowDashboard && (
                <NavItem>
                  <NavLink
                    onClick={this.toggleClose}
                    className={classnames({
                      active:
                        this.props.match.path === '/dashboard'
                        || this.props.match.path === '/',
                    })}
                    to="/dashboard"
                  >
                    <Isvg className="nav-link-icon" src={HomeIcon} />
                    <span className="nav-link-text">Dashboard</span>
                  </NavLink>
                </NavItem>
              )}
              {bolShowEventDashboard && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.props.match.path === '/events',
                    }, 'nav-link')}
                    to={`/event-dashboard/${this.props.organisations.currentOrganisation.fixtureMatchDashboardId}`}
                    target="_blank"
                  >
                    <Isvg className="nav-link-icon" src={EventsIcon} />
                    <span className="nav-link-text">Matches</span>
                    <Isvg className="nav-link-icon nav-icon-right" src={NewWindowIcon} />
                  </NavLink>
                </NavItem>
              )}
              {bolShowDashboard && bolShowCustomers && (
                <NavItem>
                  <NavLink
                    onClick={this.toggleClose}
                    className={classnames({
                      active: this.props.match.path.includes('/customers'),
                    })}
                    to="/customers"
                  >
                    <Isvg className="nav-link-icon" src={CustomersIcon} />
                    <span className="nav-link-text">Customers</span>
                  </NavLink>
                </NavItem>
              )}

              {!bolShowDashboard && bolShowCustomers && (
                <NavItem>
                  <NavLink
                    onClick={this.toggleClose}
                    className={classnames({
                      active: this.props.match.path.includes('/customers')
                        || this.props.match.path === '/',
                    })}
                    to="/customers"
                  >
                    <Isvg className="nav-link-icon" src={CustomersIcon} />
                    <span className="nav-link-text">Customers</span>
                  </NavLink>
                </NavItem>
              )}

              {bolShowTeams && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.props.match.path.includes('/teams'),
                    })}
                    to="/teams"
                  >
                    <Isvg className="nav-link-icon" src={TeamIcon} />
                    <span className="nav-link-text">Teams</span>
                    {/* <Isvg className="nav-down-arrow" src={DownArrowIcon} /> */}
                  </NavLink>
                </NavItem>
              )}

              {bolShowMatchPayments && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.props.match.path.includes('/payments/segments/matches'),
                    })}
                    to="/payments/segments/matches"
                  >
                    <Isvg className="nav-link-icon" src={EventsIcon} />
                    <span className="nav-link-text">Match Payments</span>
                  </NavLink>
                </NavItem>
              )}
              {bolShowPaymentRequests && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.props.match.path.includes('/payments/segments/requests'),
                    })}
                    to="/payments/segments/requests"
                  >
                    <Isvg className="nav-link-icon" src={RequestIcon} />
                    <span className="nav-link-text">Payment Requests</span>
                  </NavLink>
                </NavItem>
              )}

              {bolShowReports && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.props.match.path === '/reports',
                    })}
                    to="/reports"
                  >
                    <Isvg className="nav-link-icon" src={ReportsIcon} />
                    <span className="nav-link-text">Reports</span>
                    {/* <div className="nav-connection-indicator" /> */}
                  </NavLink>
                </NavItem>
              )}
            </div>
            <div className="nav-bottom">
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.props.match.path.includes('/competitions'),
                  })}
                  to="/competitions"
                >
                  <Isvg className="nav-link-icon" src={CompetitionIcon} />
                  <span className="nav-link-text">Competitions</span>
                  {/* <div className="nav-connection-indicator" /> */}
                </NavLink>
              </NavItem>
              {bolShowConnections && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.props.match.path === '/connections',
                    })}
                    to="/connections"
                  >
                    <Isvg className="nav-link-icon" src={ConnectionIcon} />
                    <span className="nav-link-text">Connections</span>
                  </NavLink>
                </NavItem>
              )}
              {bolShowBilling && (
                <NavItem>
                  <NavLink
                    // onClick={this.props.handleStripeBilling}
                    className={classnames({
                      active: this.props.match.path === '/billing',
                    })}
                    to="/billing"
                  >
                    <Isvg className="nav-link-icon" src={BillingIcon} />
                    <span className="nav-link-text">Billing</span>
                    {/* <div className="nav-connection-indicator" /> */}
                  </NavLink>
                </NavItem>
              )}
              <NavItem>
                <NavLink
                  onClick={this.toggleClose}
                  className={classnames('nav-parent-item', {
                    active: this.props.match.path.includes('/settings'),
                  })}
                  to="/settings"
                >
                  <Isvg className="nav-link-icon" src={SettingsIcon} />
                  <span className="nav-link-text">Settings</span>
                  <Isvg className="nav-down-arrow" src={DownArrowIcon} />
                </NavLink>
              </NavItem>
              <div
                className={classnames('nav-sub-group', {
                  'd-none': !this.props.match.path.includes('/settings'),
                })}
              >
                <NavItem>
                  <NavLink
                    onClick={this.toggleClose}
                    className={classnames({
                      active: this.props.match.url === '/settings',
                    })}
                    to="/settings"
                  >
                    Configuration
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={this.toggleClose}
                    className={classnames({
                      active: this.props.match.url === '/settings/bank-payouts',
                    })}
                    to="/settings/bank-payouts"
                  >
                    Bank Payouts
                  </NavLink>
                </NavItem>
              </div>
              <NavItem>
                <a
                  className="nav-link"
                  href="http://help.teammo.com.au/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Isvg className="nav-link-icon" src={HelpIcon} />
                  <span className="nav-link-text">Help & Support</span>
                </a>
              </NavItem>
              <NavItem>
                <a
                  className="nav-link"
                  href=""
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.actions.logoutUser();
                  }}
                >
                  <Isvg className="nav-link-icon" src={LogoutIcon} />
                  <span className="nav-link-text">Logout</span>
                </a>
              </NavItem>
            </div>
          </Nav>
          <div onClick={this.toggleClose} className="navbar-collapse-spacer">
            <button className="nav-menu-close" onClick={this.toggleClose}>
              <Isvg
                className="nav-menu-close-icon"
                alt="Close"
                src={CrossIcon}
              />
            </button>
          </div>
        </Collapse>
      </Navbar>
    );
  }
}
export default (TopBar);
